import I18n from "packs/i18n.js.erb";
const filesize = require("filesize");
require('blueimp-file-upload/js/jquery.iframe-transport');
require('blueimp-file-upload/js/jquery.fileupload');
require('blueimp-file-upload/js/jquery.fileupload-ui');

document.addEventListener("turbolinks:load", () => {
  const fileupload = $("#fileupload");

  if (fileupload.length) {
    const acceptFileTypesRegex = new RegExp(`(\\.|\\/)(${fileupload.data("extensions").split(",").join("|")})$`, 'i');
    const maxFileSize = fileupload.data("max-size");

    fileupload.fileupload({
      showElementClass: 'show',
      acceptFileTypes: acceptFileTypesRegex,
      maxFileSize: maxFileSize,
      uploadTemplateId: null,
      downloadTemplateId: null,
      uploadTemplate: function (o) {
        var rows = $();
        $.each(o.files, function (index, file) {
          var row = $('<tr class="template-upload fade">' +
            '<td>' +
              '<span class="name"></span>' +
            '</td>' +
            '<td>' +
              '<span class="filesize"></span>' +
            '</td>' +
            '<td>' +
              '<div class="badge-error d-none"><span class="badge badge-danger mr-1">' + I18n.t('fileupload.messages.error') + '</span><span class="error"></span></div>' +
              '<div class="progress"><div class="progress-bar" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div></div>' +
            '</td>' +
            '<td>' +
            (!index && !o.options.autoUpload ?
              '<button class="btn btn-sm btn-light mr-1 start" disabled>' + I18n.t('fileupload.start') + '</button>' : '') +
            (!index ? '<button class="btn btn-sm btn-light cancel">' + I18n.t('fileupload.cancel') + '</button>' : '') +
            '</td>' +
            '</tr>');
          row.find('.name').text(file.name);
          row.find('.filesize').text(filesize(file.size, {round: 0}));
          if (file.error) {
            row.find('.progress').addClass('d-none');
            row.find('.error').text(file.error);
            row.find('.badge-error').removeClass('d-none');
          }
          rows = rows.add(row);
        });
        if (rows) {
          fileupload.find(".table").removeClass('mb-0').addClass('mb-3');
          fileupload[0].dispatchEvent(new Event('active'));
        }
        return rows;
      },
      downloadTemplate: function (o) {
        var rows = $();
        return rows;
      },
      messages: {
        acceptFileTypes: I18n.t('fileupload.messages.accept_file_types'),
        maxFileSize: I18n.t('fileupload.messages.max_file_size') + filesize(maxFileSize, {round: 0}),
      }
    })
    .bind("fileuploadadd", function(e, data) {
      var options = {
        filename: data.files[0].name.match(/[^\/\\]+$/)[0],
        type: data.files[0].type,
        _: Date.now()
      };
      $.getJSON(e.target.dataset.presignUrl, options, function(result) {
        data.formData  = result.fields;
        data.url = result.url;
        data.paramName = "file";
      });
    })
    .bind("fileuploaddone", function(e, data) {
      var file = {
        id: data.formData.key.match(/cache\/(.+)/)[1],
        storage:  'cache',
        metadata: {
          size: data.files[0].size,
          filename: data.files[0].name.match(/[^\/\\]+$/)[0],
          mime_type: data.files[0].type
        }
      };

      var form = $(this).closest("form");
      var formData = new FormData(form[0]);
      formData.append($(this).find("input:file")[0].name, JSON.stringify(file));

      $.ajax(form.attr("action"), {
        contentType: false,
        processData: false,
        data: formData,
        method: form.attr("method"),
        dataType: "json",
        success: function(medium_data) {
          $.getScript(form.attr("action"));
          $('div#successful-upload-alerts').removeClass('d-none');
          var item_names = $('div#successful-upload-alerts').find('.item-names');
          item_names.append(medium_data.name + "; ");
        },
        error: function(xhr, status, error) {
          var errorResponse = JSON.parse(xhr.responseText);
          if (errorResponse.file) {
            $('div#failed-upload-alerts').removeClass('d-none');
            $('div#failed-upload-alerts').append("<p>" + errorResponse.file + "</p>");
          }
        }
      });
    })
    .bind('fileuploadprocessfail', function (e, data) {
      if (data.files.error) {
        data.context.each(function (index) {
          var file = data.files[index];
          if (file.error) {
            var row = $(this);
            row.find('.progress').addClass('d-none');
            row.find('.error').text(file.error);
            row.find('.badge-error').removeClass('d-none');
          }
        });
      }
    })
    .bind('fileuploadfinished', function (e, data) {
      if (fileupload.find('.show').length == 0) {
        fileupload.find(".table").removeClass('mb-3').addClass('mb-0');
        fileupload[0].dispatchEvent(new Event('inactive'));
      }
    });

    var leavePage = function(event) {
      if (fileupload.find('.start').length > 1) {
        var message = I18n.t('fileupload.messages.leave_page');
        if (event.type == "turbolinks:before-visit") {
          if (!window.confirm(message)) {
            event.preventDefault();
          } else {
            document.removeEventListener("turbolinks:before-visit", leavePage);
            window.removeEventListener("beforeunload", leavePage);
          }
        } else {
          (event || window.event).returnValue = message;
          return message;
        }
      }
    }

    window.addEventListener("beforeunload", leavePage);
    document.addEventListener("turbolinks:before-visit", leavePage);
  }
});
